import colors from './colors'

const intents = {
  info: {
    background: colors.blue25,
    border: colors.blue500,
    text: colors.blue600,
    icon: colors.blue500
  },
  success: {
    background: colors.green25,
    border: colors.green500,
    text: colors.green700,
    icon: colors.green500
  },
  warning: {
    background: colors.orange25,
    border: colors.orange500,
    text: colors.orange700,
    icon: colors.orange500
  },
  danger: {
    background: colors.red25,
    border: colors.red500,
    text: colors.red600,
    icon: colors.red500
  }
}

export default intents
